import { Outlet } from "react-router-dom";
import Header from "../../../components/header/Header.jsx";
import RecruiterSidebar from "../../sidebar/recruiterSidebar/RecruiterSidebar.jsx";

export function RecruiterLayout(){
    return (
        <div>
            <Header title='Wisdom Dashboard'/>
            <div className="layout-container">
                <RecruiterSidebar />
                <div className="layout-outlet">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}